<template>
  <div>
    <el-row>
      <el-col :span="6">
        <el-select v-model="order" placeholder="請選擇" style="display: block">
          <el-option key="rtp" label="背書總分數排名" value="rtp"></el-option>
          <el-option key="rtc" label="背書總字數排名" value="rtc"></el-option>
          <el-option
            key="rtpp"
            label="背書總分數進步排名"
            value="rtpp"
          ></el-option>
          <el-option
            key="rtcp"
            label="背書總字數進步排名"
            value="rtcp"
          ></el-option>
        </el-select>
      </el-col>

      <el-col :span="6" :offset="1">
        <span
          >當前列出前10名/共{{
            order == "rtp"
              ? rtpTableData.length
              : order == "rtc"
              ? rtcTableData.length
              : order == "rtpp"
              ? rtppTableData.length
              : order == "rtcp"
              ? rtcpTableData.length
              : 0
          }}人
        </span>
      </el-col>

      <!-- <el-col :span="3" :offset="8">
        <el-button
            class="darkblue"
            style="float: right; margin-right: 10px"
            @click="getExcel"
            >排名總表匯出</el-button
          >
      </el-col> -->
    </el-row>
    <el-row>
      <br />
      <samp style="font-size: 12px; margin-left: 10px"
        >註：法名前標示 * 者為停止學習</samp
      >
    </el-row>

    <!-- 背書總分排名 -->
    <el-table
      :data="rtpTableData"
      stripe
      style="width: 50%"
      v-if="order == 'rtp'"
      :empty-text="this.id == '' ? '尚有班級未封存成績' : '尚未封存成績'"
      :cell-style="cellStyle"
    >
      <el-table-column
        prop="studentID"
        label="學號"
        header-align="center"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="sgName"
        label="法名"
        width="100"
        header-align="center"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.suspend">{{ "*" + scope.row.sgName }}</span>
          <span v-else>{{ scope.row.sgName }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="points"
        label="總分"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="pointsOrderBy"
        label="排名"
        header-align="center"
        align="center"
      >
      </el-table-column>
    </el-table>

    <!-- 背書總字數排名 -->
    <el-table
      :data="rtcTableData"
      stripe
      style="width: 50%"
      v-if="order == 'rtc'"
      :cell-style="cellStyle"
    >
      <el-table-column
        prop="studentID"
        label="學號"
        header-align="center"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="sgName"
        label="法名"
        width="100"
        header-align="center"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.suspend">{{ "*" + scope.row.sgName }}</span>
          <span v-else>{{ scope.row.sgName }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="count"
        label="總字數"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="countOrderBy"
        label="排名"
        header-align="center"
        align="center"
      >
      </el-table-column>
    </el-table>

    <!-- 背書總分進步排名 -->
    <el-table
      :data="rtppTableData"
      stripe
      style="width: 80%"
      v-if="order == 'rtpp'"
      :cell-style="cellStyle"
    >
      <el-table-column
        prop="studentID"
        label="學號"
        header-align="center"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="sgName"
        label="法名"
        width="100"
        header-align="center"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.suspend">{{ "*" + scope.row.sgName }}</span>
          <span v-else>{{ scope.row.sgName }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="points"
        label="此次背書總分"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="pointsL"
        label="上次背書總分"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="pointsP"
        label="進步分數"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="pointsPOrderBy"
        label="排名"
        header-align="center"
        align="center"
      >
      </el-table-column>
    </el-table>

    <!-- 背書總字數進步排名 -->
    <el-table
      :data="rtcpTableData"
      stripe
      style="width: 80%"
      v-if="order == 'rtcp'"
      :cell-style="cellStyle"
    >
      <el-table-column
        prop="studentID"
        label="學號"
        header-align="center"
        align="center"
      ></el-table-column>

      <el-table-column
        prop="sgName"
        label="法名"
        width="100"
        header-align="center"
        align="center"
      >
        <template scope="scope">
          <span v-if="scope.row.suspend">{{ "*" + scope.row.sgName }}</span>
          <span v-else>{{ scope.row.sgName }}</span>
        </template>
      </el-table-column>

      <el-table-column
        prop="count"
        label="此次背書總字數"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="countL"
        label="上次背書總字數"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="countP"
        label="進步字數"
        header-align="center"
        align="center"
      >
      </el-table-column>

      <el-table-column
        prop="countPOrderBy"
        label="排名"
        header-align="center"
        align="center"
      >
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import API from "@/api";
import Utils from "@/utils";
import XLSX from "xlsx";
// import { InformType } from "@/utils/InformType";

export default {
  name: "orderTab",

  data() {
    return {
      rtpTableData: [],
      rtcTableData: [],
      rtppTableData: [],
      rtcpTableData: [],
      tableData: [],
      order: "rtp",
    };
  },

  created() {
    this.query();
  },
  props: {
    clickTime: Date,
    year: { String, default: "" },
    id: { String, default: "" },
    name: { String, default: "" },
  },

  watch: {
    clickTime: function () {
      console.log("clickTime watch");
      console.log("id", this.year, this.id);
      this.query();
    },
  },

  methods: {
    cellStyle(params) {
      if (params.row.suspend) {
        return "color: #B5B5B5";
      }
      return "";
    },
    query() {
      if (Utils.Check.isNull(this.year)) return;
      console.log("讀取");
      this.isLoading = true;
      API.orderBy.findAll(this.year, this.id).then((res) => {
        this.rtpTableData = res.data.rtp;
        this.rtcTableData = res.data.rtc;
        this.rtppTableData = res.data.rtpp;
        this.rtcpTableData = res.data.rtcp;
        console.log(res.data);
        this.isLoading = false;
      });
    },
    getExcel() {
      if (Utils.Check.isNull(this.year)) return;
      console.log("讀取EXCEL 內容");
      this.isLoading = true;
      API.orderBy.findAllExcel(this.year, this.id).then((res) => {
        console.log(res.data);
        let rtp = res.data.rtp;
        let rtc = res.data.rtc;
        let rtpp = res.data.rtpp;
        let rtcp = res.data.rtcp;

        rtp.unshift(["學號", "法名", "總分", "排名"]);
        rtc.unshift(["學號", "法名", "總字數", "排名"]);
        rtpp.unshift([
          "學號",
          "法名",
          "此次背書總分",
          "上次背書總分",
          "進步分數",
          "排名",
        ]);
        rtcp.unshift([
          "學號",
          "法名",
          "此次背書總字數",
          "上次背書總字數",
          "進步字數",
          "排名",
        ]);

        const ws1 = XLSX.utils.aoa_to_sheet(rtp);
        const ws2 = XLSX.utils.aoa_to_sheet(rtc);
        const ws3 = XLSX.utils.aoa_to_sheet(rtpp);
        const ws4 = XLSX.utils.aoa_to_sheet(rtcp);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, "背書總分數排名");
        XLSX.utils.book_append_sheet(wb, ws2, "背書總字數排名");
        XLSX.utils.book_append_sheet(wb, ws3, "背書總分數進步排名");
        XLSX.utils.book_append_sheet(wb, ws4, "背書總字數進步排名");

        /* generate file and send to client */
        if (Utils.Check.isNull(this.id)) XLSX.writeFile(wb, "全寺排名.xlsx");
        else XLSX.writeFile(wb, `${this.name}排名.xlsx`);

        this.isLoading = false;
      });
    },
  },
};
</script>

<style>
.darkblue {
  background-color: #527bae;
  color: #ffffff;
}
</style>